import { render, staticRenderFns } from "./remark.vue?vue&type=template&id=b6b0801a&scoped=true"
import script from "./remark.vue?vue&type=script&lang=js"
export * from "./remark.vue?vue&type=script&lang=js"
import style0 from "./remark.vue?vue&type=style&index=0&id=b6b0801a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b0801a",
  null
  
)

export default component.exports